
import { Vue, Component } from 'vue-property-decorator'
import { getGuaranteeBrushFace, signGuarantee } from '@/api/guarantee'
@Component
export default class guaranteeResult extends Vue {
  timer = 60
  isPass = false
  timerId = null
  // 是否已经签署
  isGuarantee = false
  // 状态
  status = 0
  statusArr = [
    {
      type: 1,
      text: '识别中...',
      options: '',
      icon: 'icon-dengdai1'
    },
    {
      type: 2,
      text: '识别通过',
      options: '签署',
      icon: 'icon-gou'
    },
    {
      type: 3,
      text: '识别不通过',
      options: '返回',
      icon: 'icon-guanbi'
    }
  ]

  handleBack() {
    this.$router.replace({
      name: 'GuaranteeFace',
      query: JSON.parse(window.sessionStorage.getItem('guarantee'))
    })
  }
  handleBtn() {
    clearInterval(this.timerId)
    this.isSuccess()

    // this.$router.replace({
    //   name:'GuaranteeSuccess'
    // })
  }
  created() {
    this.getGuaranteeBrushFace()
  }
  // 获取刷脸结果
  getGuaranteeBrushFace() {
    let { opUser, companyId, orderNo } = JSON.parse(
      window.sessionStorage.getItem('guarantee')
    )
    this.$store.state.user.info.userId = opUser
    getGuaranteeBrushFace({
      companyId,
      orderNo
    })
      .then((res) => {
        if (res.code === '000000') {
          this.status = 1
        } else {
          this.status = 2
          this.timerId = setInterval(() => {
            this.timer--
            if (this.timer < 1) {
              this.isSuccess()
              clearInterval(this.timerId)
            }
          }, 1000)
        }
      })
      .catch(() => {
        this.status = 2
        this.timerId = setInterval(() => {
          this.timer--
          if (this.timer < 1) {
            this.isSuccess()
            clearInterval(this.timerId)
          }
        }, 1000)
      })
  }
  isSuccess() {
    if (this.status === 1) {
      // 防止重复点击
      if (this.isGuarantee) return
      // this.isGuarantee = true
      // setTimeout(() => {
      //   this.isGuarantee = false
      //   this.status = 2
      // }, 2000)
      this.signGuarantee()
    } else {
      this.$router.replace({
        name: 'GuaranteeFace',
        query: JSON.parse(window.sessionStorage.getItem('guarantee'))
      })
    }
  }
  // 签署担保函
  signGuarantee() {
    this.isGuarantee = true
    let { companyId, guaranteeId } = JSON.parse(
      window.sessionStorage.getItem('guarantee')
    )
    let params = {
      companyId,
      guaranteeId
    }
    signGuarantee(params)
      .then((res) => {
        console.log('signGuarantee', res)

        if (res.code === '000000') {
          this.$router.push({
            name: 'GuaranteeSuccess'
          })
        }
      })
      .catch((res) => {
        console.log('catch', res)

        this.$toast(res.data.msg)
      })
      .finally(() => {
        this.isGuarantee = false
      })
  }
}
